// US ZIP Code Geolocation & Distance Calculation Utility
// Maps 3-digit ZIP prefixes to geographic coordinates for instant offline distance estimation

// Representative coordinate centers for 3-digit ZIP prefixes (005 - 999)
const ZIP_PREFIX_COORDS: Record<string, [number, number]> = {
  // New England (010 - 069)
  '010': [42.37, -72.52], '011': [42.10, -72.59], '012': [42.45, -73.25], '013': [42.59, -72.60],
  '014': [42.58, -71.80], '015': [42.26, -71.80], '016': [42.27, -71.80], '017': [42.40, -71.40],
  '018': [42.64, -71.32], '019': [42.52, -70.90], '020': [42.18, -71.18], '021': [42.36, -71.06],
  '022': [42.35, -71.07], '023': [42.08, -71.02], '024': [42.34, -71.21], '025': [41.70, -70.30],
  '026': [41.70, -70.30], '027': [41.70, -71.15], '028': [41.58, -71.48], '029': [41.82, -71.41],
  '030': [42.99, -71.46], '031': [42.99, -71.46], '032': [43.21, -71.54], '033': [43.21, -71.54],
  '034': [42.93, -72.28], '035': [44.40, -71.50], '036': [43.15, -72.45], '037': [43.64, -72.32],
  '038': [43.07, -70.76], '039': [43.14, -70.65], '040': [43.66, -70.26], '041': [43.66, -70.26],
  '042': [44.10, -70.22], '043': [44.31, -69.78], '044': [44.80, -68.78], '045': [43.91, -69.72],
  '046': [44.72, -67.46], '047': [46.68, -68.01], '048': [44.21, -69.07], '049': [44.55, -69.63],
  '050': [43.65, -72.52], '051': [43.15, -72.45], '052': [42.88, -73.19], '053': [42.85, -72.56],
  '054': [44.48, -73.21], '055': [42.64, -71.32], '056': [44.26, -72.58], '057': [43.61, -72.97],
  '058': [44.42, -72.02], '059': [44.51, -71.65], '060': [41.76, -72.67], '061': [41.76, -72.67],
  '062': [41.71, -71.82], '063': [41.35, -72.10], '064': [41.31, -72.92], '065': [41.31, -72.92],
  '066': [41.18, -73.19], '067': [41.56, -73.04], '068': [41.14, -73.36], '069': [41.05, -73.54],
  // NY & NJ (070 - 149)
  '070': [40.73, -74.17], '071': [40.74, -74.17], '072': [40.66, -74.21], '073': [40.73, -74.08],
  '074': [40.92, -74.17], '075': [40.92, -74.17], '076': [40.89, -74.04], '077': [40.35, -74.07],
  '078': [40.85, -74.83], '079': [40.79, -74.48], '080': [39.92, -75.03], '081': [39.94, -75.12],
  '082': [39.36, -74.42], '083': [39.49, -75.03], '084': [39.36, -74.42], '085': [40.22, -74.76],
  '086': [40.22, -74.76], '087': [40.06, -74.14], '088': [40.50, -74.45], '089': [40.50, -74.45],
  '100': [40.71, -74.01], '101': [40.75, -73.98], '102': [40.71, -74.01], '103': [40.58, -74.15],
  '104': [40.84, -73.87], '105': [41.03, -73.76], '106': [41.03, -73.76], '107': [40.93, -73.90],
  '108': [40.91, -73.78], '109': [41.15, -74.05], '110': [40.75, -73.70], '111': [40.75, -73.93],
  '112': [40.68, -73.94], '113': [40.73, -73.82], '114': [40.70, -73.80], '115': [40.73, -73.63],
  '116': [40.58, -73.82], '117': [40.79, -73.42], '118': [40.77, -73.53], '119': [40.92, -72.66],
  '120': [42.65, -73.76], '121': [42.65, -73.76], '122': [42.65, -73.76], '123': [42.81, -73.94],
  '124': [41.93, -74.01], '125': [41.70, -73.92], '126': [41.70, -73.92], '127': [41.65, -74.69],
  '128': [43.31, -73.64], '129': [44.70, -73.46], '130': [43.05, -76.15], '131': [43.05, -76.15],
  '132': [43.05, -76.15], '133': [43.10, -75.23], '134': [43.10, -75.23], '135': [43.10, -75.23],
  '136': [43.97, -75.91], '137': [42.10, -75.91], '138': [42.10, -75.91], '139': [42.10, -75.91],
  '140': [42.89, -78.88], '141': [42.89, -78.88], '142': [42.89, -78.88], '143': [43.09, -79.05],
  '144': [43.16, -77.61], '145': [43.16, -77.61], '146': [43.16, -77.61], '147': [42.10, -79.24],
  '148': [42.09, -76.81], '149': [42.09, -76.81],
  // PA & DE (150 - 199)
  '150': [40.44, -79.99], '151': [40.44, -79.99], '152': [40.44, -79.99], '153': [40.17, -80.25],
  '154': [39.90, -79.73], '155': [40.01, -78.50], '156': [40.30, -79.54], '157': [40.62, -79.15],
  '158': [41.12, -78.76], '159': [40.33, -78.92], '160': [40.86, -79.89], '161': [41.00, -80.35],
  '162': [40.82, -79.52], '163': [41.43, -79.71], '164': [42.13, -80.09], '165': [42.13, -80.09],
  '166': [40.52, -78.40], '167': [41.95, -78.65], '168': [40.79, -77.86], '169': [41.75, -77.30],
  '170': [40.27, -76.88], '171': [40.27, -76.88], '172': [39.93, -77.66], '173': [39.96, -76.73],
  '174': [39.96, -76.73], '175': [40.04, -76.31], '176': [40.04, -76.31], '177': [41.24, -77.00],
  '178': [40.86, -76.79], '179': [40.68, -76.20], '180': [40.60, -75.47], '181': [40.60, -75.47],
  '182': [40.96, -75.97], '183': [40.99, -75.19], '184': [41.41, -75.66], '185': [41.41, -75.66],
  '186': [41.25, -75.88], '187': [41.25, -75.88], '188': [41.77, -76.45], '189': [40.31, -75.13],
  '190': [39.95, -75.17], '191': [39.95, -75.17], '192': [39.95, -75.17], '193': [39.96, -75.60],
  '194': [40.12, -75.34], '195': [40.34, -75.93], '196': [40.34, -75.93], '197': [39.68, -75.75],
  '198': [39.74, -75.55], '199': [39.16, -75.52],
  // Mid-Atlantic & South (200 - 399)
  '200': [38.91, -77.04], '201': [38.75, -77.47], '202': [38.91, -77.04], '203': [38.85, -76.95],
  '204': [38.91, -77.04], '205': [38.91, -77.04], '206': [38.53, -76.88], '207': [38.98, -76.94],
  '208': [39.08, -77.15], '209': [39.00, -77.03], '210': [39.29, -76.61], '211': [39.29, -76.61],
  '212': [39.29, -76.61], '214': [38.98, -76.49], '215': [39.65, -78.76], '216': [38.77, -76.08],
  '217': [39.41, -77.41], '218': [38.36, -75.60], '219': [39.61, -75.83], '220': [38.85, -77.30],
  '221': [38.85, -77.30], '222': [38.88, -77.10], '223': [38.80, -77.05], '224': [38.30, -77.46],
  '225': [38.30, -77.46], '226': [39.19, -78.16], '227': [38.47, -78.00], '228': [38.45, -78.87],
  '229': [38.03, -78.48], '230': [37.54, -77.44], '231': [37.54, -77.44], '232': [37.54, -77.44],
  '233': [36.77, -76.29], '234': [36.85, -75.98], '235': [36.85, -76.29], '236': [37.03, -76.35],
  '237': [36.84, -76.30], '238': [37.23, -77.40], '239': [37.30, -78.39], '240': [37.27, -79.94],
  '241': [37.27, -79.94], '242': [36.60, -82.18], '243': [36.95, -81.08], '244': [38.15, -79.07],
  '245': [37.41, -79.14], '270': [36.10, -80.24], '271': [36.10, -80.24], '272': [35.95, -79.80],
  '273': [35.95, -79.80], '274': [35.95, -79.80], '275': [35.77, -78.64], '276': [35.77, -78.64],
  '277': [35.99, -78.90], '278': [35.61, -77.37], '279': [36.30, -76.22], '280': [35.23, -80.84],
  '281': [35.23, -80.84], '282': [35.23, -80.84], '283': [35.05, -78.88], '284': [34.23, -77.94],
  '285': [35.10, -77.04], '286': [35.72, -81.34], '287': [35.60, -82.55], '288': [35.60, -82.55],
  '290': [34.00, -81.03], '291': [34.00, -81.03], '292': [34.00, -81.03], '293': [34.95, -81.93],
  '294': [32.78, -79.93], '295': [34.20, -79.76], '296': [34.85, -82.40], '297': [34.92, -81.03],
  '300': [33.75, -84.39], '301': [33.75, -84.39], '302': [33.75, -84.39], '303': [33.75, -84.39],
  '304': [32.45, -81.78], '305': [34.30, -83.82], '306': [33.95, -83.38], '307': [34.77, -84.97],
  '308': [33.47, -81.97], '309': [33.47, -81.97], '310': [32.84, -83.63], '311': [33.75, -84.39],
  '312': [32.84, -83.63], '313': [31.84, -81.60], '314': [32.08, -81.09], '315': [31.15, -81.49],
  '316': [30.83, -83.28], '317': [31.58, -84.16], '318': [32.46, -84.99], '319': [32.46, -84.99],
  '320': [30.33, -81.66], '321': [29.21, -81.02], '322': [30.33, -81.66], '323': [30.44, -84.28],
  '324': [30.16, -85.66], '325': [30.42, -87.22], '326': [29.65, -82.32], '327': [28.54, -81.38],
  '328': [28.54, -81.38], '329': [28.08, -80.61], '330': [25.76, -80.19], '331': [25.76, -80.19],
  '332': [25.76, -80.19], '333': [26.12, -80.14], '334': [26.72, -80.05], '335': [27.95, -82.46],
  '336': [27.95, -82.46], '337': [27.77, -82.64], '338': [28.04, -81.95], '339': [26.64, -81.87],
  '341': [26.14, -81.80], '342': [27.34, -82.53], '344': [29.19, -82.14], '346': [28.32, -82.70],
  '347': [28.80, -81.75], '349': [27.27, -80.35],
  // Midwest & Central (400 - 699)
  '400': [38.25, -85.76], '401': [38.25, -85.76], '402': [38.25, -85.76], '403': [38.04, -84.50],
  '404': [37.64, -84.77], '405': [38.04, -84.50], '406': [38.20, -84.87], '410': [39.08, -84.51],
  '430': [39.96, -83.00], '431': [39.96, -83.00], '432': [39.96, -83.00], '433': [40.59, -83.13],
  '434': [41.35, -83.65], '435': [41.65, -83.54], '436': [41.65, -83.54], '440': [41.50, -81.69],
  '441': [41.50, -81.69], '442': [41.08, -81.52], '443': [41.08, -81.52], '444': [41.10, -80.65],
  '445': [41.10, -80.65], '446': [40.80, -81.38], '447': [40.80, -81.38], '448': [40.76, -82.52],
  '449': [40.76, -82.52], '450': [39.10, -84.51], '451': [39.10, -84.51], '452': [39.10, -84.51],
  '453': [39.76, -84.19], '454': [39.76, -84.19], '455': [39.93, -83.81], '456': [38.74, -82.99],
  '457': [39.33, -82.10], '458': [40.74, -84.11], '460': [39.77, -86.16], '461': [39.77, -86.16],
  '462': [39.77, -86.16], '463': [41.59, -87.35], '464': [41.59, -87.35], '465': [41.68, -86.25],
  '466': [41.68, -86.25], '467': [41.08, -85.14], '468': [41.08, -85.14], '469': [40.49, -86.13],
  '470': [39.09, -84.85], '471': [38.28, -85.74], '472': [39.20, -85.92], '473': [40.19, -85.39],
  '474': [39.17, -86.53], '475': [38.38, -86.93], '476': [37.97, -87.57], '477': [37.97, -87.57],
  '478': [39.47, -87.41], '479': [40.42, -86.88], '480': [42.33, -83.05], '481': [42.28, -83.74],
  '482': [42.33, -83.05], '483': [42.64, -83.30], '484': [43.01, -83.69], '485': [43.01, -83.69],
  '486': [43.43, -83.95], '487': [43.59, -83.89], '488': [42.73, -84.56], '489': [42.73, -84.56],
  '490': [42.29, -85.59], '491': [41.83, -86.26], '492': [42.25, -84.40], '493': [42.96, -85.67],
  '494': [42.96, -85.67], '495': [42.96, -85.67], '496': [44.76, -85.62], '497': [45.37, -84.96],
  '498': [46.54, -87.40], '499': [46.54, -87.40],
  '500': [41.59, -93.60], '501': [41.59, -93.60], '502': [41.59, -93.60], '503': [41.59, -93.60],
  '530': [43.04, -87.91], '531': [43.04, -87.91], '532': [43.04, -87.91], '535': [43.07, -89.40],
  '537': [43.07, -89.40], '540': [44.95, -92.76], '543': [44.52, -88.02], '549': [44.02, -88.54],
  '550': [44.98, -93.27], '551': [44.95, -93.09], '553': [44.98, -93.27], '554': [44.98, -93.27],
  '559': [44.02, -92.47], '581': [46.88, -96.79], '585': [46.81, -100.78],
  '590': [45.78, -108.50], '591': [45.78, -108.50], '597': [45.68, -111.04], '598': [46.87, -113.99],
  '600': [41.88, -87.63], '601': [41.88, -87.63], '602': [42.05, -87.69], '603': [41.89, -87.79],
  '604': [41.53, -88.08], '605': [41.76, -88.32], '606': [41.88, -87.63], '607': [41.97, -87.81],
  '608': [41.73, -87.72], '611': [42.27, -89.09], '616': [40.69, -89.59], '618': [40.12, -88.24],
  '627': [39.78, -89.65], '630': [38.63, -90.20], '631': [38.63, -90.20], '633': [38.78, -90.51],
  '640': [39.10, -94.58], '641': [39.10, -94.58], '658': [37.21, -93.29], '660': [38.97, -95.24],
  '661': [39.11, -94.63], '662': [38.98, -94.67], '666': [39.05, -95.68], '672': [37.69, -97.34],
  '680': [41.26, -95.94], '681': [41.26, -95.94], '685': [40.81, -96.70],
  // Texas & Southwest (700 - 899)
  '700': [29.95, -90.07], '701': [29.95, -90.07], '708': [30.45, -91.19], '711': [32.53, -93.75],
  '722': [34.75, -92.29], '730': [35.47, -97.52], '731': [35.47, -97.52], '741': [36.15, -95.99],
  '750': [32.96, -96.83], '751': [32.78, -96.80], '752': [32.78, -96.80], '753': [32.78, -96.80],
  '760': [32.74, -97.33], '761': [32.74, -97.33], '770': [29.76, -95.37], '771': [29.76, -95.37],
  '772': [29.76, -95.37], '773': [30.16, -95.46], '774': [29.58, -95.76], '775': [29.53, -95.12],
  '780': [29.42, -98.49], '781': [29.42, -98.49], '782': [29.42, -98.49], '786': [30.27, -97.74],
  '787': [30.27, -97.74], '791': [35.22, -101.83], '794': [33.58, -101.86], '799': [31.76, -106.49],
  '800': [39.74, -104.99], '801': [39.58, -104.98], '802': [39.74, -104.99], '803': [40.01, -105.27],
  '805': [40.59, -105.08], '809': [38.83, -104.82], '820': [41.14, -104.82], '837': [43.62, -116.20],
  '840': [40.76, -111.89], '841': [40.76, -111.89], '846': [40.23, -111.66], '850': [33.45, -112.07],
  '852': [33.42, -111.94], '853': [33.54, -112.19], '857': [32.22, -110.97], '871': [35.08, -106.65],
  '875': [35.69, -105.94], '890': [36.04, -115.00], '891': [36.17, -115.14], '895': [39.53, -119.81],
  // West Coast (900 - 999)
  '900': [34.05, -118.24], '902': [34.07, -118.40], '904': [34.02, -118.50], '906': [33.95, -118.04],
  '908': [33.77, -118.19], '911': [34.15, -118.14], '913': [34.18, -118.54], '914': [34.18, -118.45],
  '915': [34.18, -118.31], '917': [34.07, -117.97], '920': [33.16, -117.35], '921': [32.72, -117.16],
  '925': [33.95, -117.40], '926': [33.68, -117.83], '927': [33.74, -117.87], '928': [33.84, -117.91],
  '930': [34.27, -119.23], '931': [34.42, -119.70], '933': [35.37, -119.02], '934': [35.28, -120.66],
  '937': [36.75, -119.77], '940': [37.56, -122.33], '941': [37.77, -122.42], '943': [37.44, -122.16],
  '945': [37.80, -122.27], '946': [37.80, -122.27], '949': [37.97, -122.53], '950': [36.97, -122.03],
  '951': [37.34, -121.89], '954': [38.44, -122.71], '956': [38.58, -121.49], '958': [38.58, -121.49],
  '970': [45.52, -122.68], '971': [45.52, -122.68], '972': [45.52, -122.68], '973': [44.94, -123.04],
  '974': [44.05, -123.09], '977': [44.06, -121.32], '980': [47.61, -122.20], '981': [47.61, -122.33],
  '982': [47.98, -122.20], '983': [47.25, -122.44], '984': [47.25, -122.44], '985': [47.04, -122.90],
  '992': [47.66, -117.43], '995': [61.22, -149.90], '968': [21.31, -157.86]
};

/**
 * Validate 5-digit US ZIP code format
 */
export function isValidZip(zip: string): boolean {
  return /^\d{5}$/.test(zip.trim());
}

/**
 * Get approximate coordinates for any 5-digit US zip code
 */
export function getZipCoordinates(zip: string): [number, number] | null {
  const cleanZip = zip.trim().slice(0, 5);
  if (!/^\d{5}$/.test(cleanZip)) return null;

  const prefix = cleanZip.substring(0, 3);
  if (ZIP_PREFIX_COORDS[prefix]) {
    return ZIP_PREFIX_COORDS[prefix];
  }

  // Fallback: check 2-digit range or nearest prefix
  const prefixNum = parseInt(prefix, 10);
  let closestKey = '';
  let minDiff = Infinity;

  for (const key of Object.keys(ZIP_PREFIX_COORDS)) {
    const diff = Math.abs(parseInt(key, 10) - prefixNum);
    if (diff < minDiff) {
      minDiff = diff;
      closestKey = key;
    }
  }

  return closestKey ? ZIP_PREFIX_COORDS[closestKey] : null;
}

/**
 * Calculate distance in miles using the Haversine formula
 */
export function haversineDistanceMiles(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 3958.8; // Earth's radius in miles
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.round(R * c);
}

/**
 * Calculate distance in miles between two ZIP codes
 * Returns 0 if identical, or calculated miles, or null if invalid
 */
export function getZipDistance(zip1: string, zip2: string): number | null {
  const z1 = zip1.trim().slice(0, 5);
  const z2 = zip2.trim().slice(0, 5);

  if (z1 === z2) return 0;

  const coords1 = getZipCoordinates(z1);
  const coords2 = getZipCoordinates(z2);

  if (!coords1 || !coords2) return null;

  return haversineDistanceMiles(coords1[0], coords1[1], coords2[0], coords2[1]);
}
